/**
 * LoadingState - Loading state component for knowledge base
 * 
 * PROJECT_RULES.md Compliance:
 * - ✅ Mobile: Safe area handling
 * - ✅ Consistent design language
 */

import React from 'react';
import LandingHeader from '../../LandingHeader';
import Footer from '../../../../components/Footer';
import { isIOSDevice } from '../../../utils/deviceDetection';
import { BACKGROUND_COLORS } from '../constants';

export const LoadingState: React.FC = () => {
  const isIOS = isIOSDevice();

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: BACKGROUND_COLORS.loading }}>
      <LandingHeader />
      <div 
        className="flex-grow container mx-auto px-4 py-8 max-w-4xl"
        style={{ 
          marginTop: isIOS ? 'calc(4rem + env(safe-area-inset-top, 0px))' : '4rem'
        }}
      >
        <div className="animate-pulse">
          <div className="h-8 bg-gray-300 rounded w-3/4 mb-4"></div>
          <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
          <div className="h-4 bg-gray-300 rounded w-5/6 mb-2"></div>
          <div className="h-4 bg-gray-300 rounded w-4/6"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};